import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import { AccountCircle, KeyboardArrowDown } from "@mui/icons-material"
import { useAuthenticator } from "@aws-amplify/ui-react";


export interface ProfileButtonProps {
    username?: string
}

export function ProfileButton(props: ProfileButtonProps) {
    const { user, signOut } = useAuthenticator((context) => [context.user]);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <React.Fragment>
            <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
                <Tooltip title="Account settings">
                    <IconButton
                        onClick={handleClick}
                        size="large"
                        edge="end"
                        color="inherit"
                        aria-controls={open ? "account-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                    >
                        <AccountCircle />
                        <Typography
                            component="h1"
                            variant="h6"
                            color="inherit"
                            noWrap
                            sx={{ flexGrow: 0.98, paddingLeft: 1 }}>
                            {user.attributes?.email}
                        </Typography>
                        <KeyboardArrowDown />
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                color="inherit"
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    color: "inherit",
                    sx: {
                        width: 300,
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0
                        }
                    }
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
                <MenuItem onClick={handleClose} color="white">
                    <AccountCircle color="secondary" />
                    <Label text="Profile" />
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleClose}>
                    <Settings color="secondary" />
                    <Label text="Settings" />
                </MenuItem>
                <MenuItem onClick={signOut}>
                    <Logout color="error" />
                    <Label text="Logout" color='red' />
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}

function Label({ text, color = 'white' }: { text: string, color?: string }) {
    return <Typography
        component="h1"
        variant="h6"
        color={color}
        noWrap
        sx={{ flexGrow: 0.98, paddingLeft: 1 }}>
        {text}
    </Typography>
}
